import { frameworkCommonGame } from "../../../core/components/commongame/configuration/commongameconfiguration"
import { commongameAssetConfig } from "../../../data/commongame/index";

frameworkCommonGame.data = {

    "COMPONENTS": [
        {
            "id": "GameCommonGameContainer",
            "name": "GameCommonGameContainer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "parentLayer": "baseLayer",
            child: [
                {
                    "id": "GameCommonGameComponent",
                    "name": "GameCommonGame",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    child: [



                        {
                            "name": "BG_frame_Image_Desktop",
                            "image": "Bg_frame",
                            "type": "Image",
                            "layout": false,
                            "uimode": "desktop",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            "width": 1924,
                            "height": 1084,
                            "x": 957.5,
                            "y": 542.5
                        },
                        {
                            "name": "BG_frame_Image_Mobile",
                            "image": "Bg_frame",
                            "type": "Image",
                            "layout": true,
                            "uimode": "mobile",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            "width": 1859,
                            "height": 1008,
                            "x": 959.5,
                            "y": 539.5
                        },

                        {
                            "name": "image_basegame-bg_desktop",
                            "image": "baseGameBgImage",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 1920,
                            "height": 1080,
                            "x": 0,
                            "y": 0
                        },
                        {
                            "name": "image_basegame-bg_mobile",
                            "image": "baseGameBgImage",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": false,
                            "width": 1920,
                            "height": 1080,
                            "x": 0,
                            "y": 0
                        },
                        {
                            "name": "image_commongame-potrait-bg",
                            "image": "commongamePotraitBG",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 1080,
                            "height": 1920,
                            "x": 0,
                            "y": 0
                        },


                        {
                            "name": "image_commongame-potrait-fg",
                            "image": "commongamePotraitFG",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": false,
                            "width": 1080,
                            "height": 1920,
                            "x": 0,
                            "y": 0
                        },
                        {
                            "name": "image_freegame-fg",
                            "image": "freeGameBgImage",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": false,
                            "width": 1922,
                            "height": 1082,
                            "x": 0,
                            "y": 0
                        },
                        {
                            "name": "image_freegame-fg",
                            "image": "freeGameBgImage",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": false,
                            "width": 1922,
                            "height": 1082,
                            "x": 0,
                            "y": 0
                        },
                    ]
                }
            ]
        }
    ]

}